import { motion } from "framer-motion";

export default function KineticHeading({ lines, className = "", testId = "kinetic-heading" }) {
  return (
    <h1 className={className} data-testid={testId}>
      {lines.map((line, index) => (
        <span key={line} className="block overflow-hidden pb-1">
          <motion.span
            data-testid={`${testId}-line-${index + 1}`}
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay: 0.18 + index * 0.13, ease: [0.76, 0, 0.24, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}
